import { calculateDateDifference } from '@/helpers'
import { QuotationRequestProps } from '@/types'

export enum ReferenceColumnStatusEnum {
  'default' = 'default',
  'success' = 'success',
  'warning' = 'warning',
  'danger' = 'danger',
}

export const getReferenceColumnStatus = (record: QuotationRequestProps) => {
  const now = new Date()
  const createdAt = new Date(record?.createdAt)

  if (
    record?.status === 'pending' &&
    calculateDateDifference(createdAt, now) > 5
  ) {
    return ReferenceColumnStatusEnum.danger
  }

  if (
    record?.status === 'pending' &&
    calculateDateDifference(createdAt, now) > 3
  ) {
    return ReferenceColumnStatusEnum.warning
  }

  if (
    record?.status === 'pending' &&
    calculateDateDifference(createdAt, now) === 0
  ) {
    return ReferenceColumnStatusEnum.success
  }

  return ReferenceColumnStatusEnum.default
}

export const getStatusByTab = (tab: string) => {
  switch (tab) {
    case 'pending-acquisition':
      return 'pending,'
    case 'pending-supply':
      return 'approved_for_quotation,qualified'
    case 'invalid':
      return 'invalid,'
    case 'expired':
      return 'expired,'
    default:
      return ''
  }
}
